import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AnalyticsConsent from './AnalyticsConsent';

const ScrollToTopOnRouteChange: React.FC = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

const SiteLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollToTopOnRouteChange />
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
      <AnalyticsConsent />
    </div>
  );
};

export default SiteLayout;
